module.exports = __webpack_public_path__ + "img/button_cod_secreto.01b4f93d.png";